import { GetSourceDataNoteCollectionByPatientStudyNumber, SourceDataNoteCollectionResponse } from '@/api/dtos';
import { useGet, usePost } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<SourceDataNoteCollectionResponse, SourceDataNoteCollectionResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<SourceDataNoteCollectionResponse, SourceDataNoteCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useSourceDataNotesByPatientStudyNumber = (patientStudyNumber?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return patientStudyNumber ? 
            () => new GetSourceDataNoteCollectionByPatientStudyNumber({ patientStudyNumber: patientStudyNumber }) : 
            undefined;
    }, [patientStudyNumber]);

    return useGet(request, { getData, getError}, configuration);
};

export default useSourceDataNotesByPatientStudyNumber;